module.exports = __webpack_public_path__ + "static/media/HIL2.fd28bc47.png";